import styled, { css } from 'styled-components';
import { Checkbox, NotificationBanner, Button } from 'components/atoms';
import { DropdownWithLabel, InputWithValidation } from '../../molecules';
import { Form, Input, Dropdown } from 'semantic-ui-react';
import { ReactComponent as IconError } from 'resources/images/ic-error.svg';
import { DefaultTheme, ThemedStyledProps } from 'styled-components/macro';

export const StyledForm = styled(Form)`
  ${props =>
    props.isForModal
      ? css`
          &&&& {
            position: relative;
            top: ${props.theme.pxToRem(-30)};
            width: ${props.theme.pxToRem(520)};
            ${props.theme.mediaQueries.mobileOnly} {
              width: ${props.theme.pxToRem(296)};
            }
          }
        `
      : css`
          &&&& {
            max-width: ${props.theme.pxToRem(455)};
            ${props.theme.mediaQueries.mobileOnly} {
              width: ${props.theme.pxToRem(296)};
            }
          }
        `}

  .ui.selection.active.dropdown,
  .ui.selection.active.dropdown .menu {
    border: solid ${props => props.theme.pxToRem(1)} ${props => props.theme.colors.primaryPurple}!important;
  }

  .ui.selection.dropdown .menu {
    width: calc(100% - 1.5px) !important;
    min-width: calc(100% + 1px) !important;
  }

  .ui.dropdown .menu > .item:hover {
    color: ${props => props.theme.colors.primaryPurple}!important;
  }
`;

export const StyledLabelBusinessName = styled.label`
  margin-bottom: ${props => props.theme.pxToRem(8)};
  font-size: ${props => props.theme.fontSizes.s};
  color: ${props => props.theme.colors.neutralGrey8};
  display: block;
`;

export const StyledCMHeading = styled.h3`
  margin-bottom: ${props => props.theme.pxToRem(20)};
  font-size: ${props => props.theme.fontSizes.l};
  font-weight: ${props => props.theme.fontWeights.medium};
  color: ${props => props.theme.colors.neutralGrey8};
`;

export const StyledDropdownMenuItem = styled(Dropdown.Item)`
  &&&&& {
    font-size: ${props => props.theme.fontSizes.s};
    font-weight: ${props => props.theme.fontWeights.medium};
    color: ${props => props.theme.colors.primaryPurple};

    &:hover {
      color: ${props => props.theme.colors.primaryPurple};
    }
  }
`;

export const StyledVerticalLine = styled.div`
  margin-top: ${props => props.theme.pxToRem(24)};
  border-left: solid ${props => props.theme.pxToRem(1)} ${props => props.theme.colors.neutralGrey5};
  display: inline-block;
  width: 100%;
  padding-left: ${props => props.theme.pxToRem(23)};
`;

export const StyledLabelBusinessCity = styled.label`
  margin-top: ${props => props.theme.pxToRem(32)};
  margin-bottom: ${props => props.theme.pxToRem(8)};

  font-size: ${props => props.theme.fontSizes.s};
  font-weight: ${props => props.theme.fontWeights.medium};
  color: ${props => props.theme.colors.neutralGrey8};

  display: block;
`;

export const StyledEdit = styled.div`
  &:hover {
    text-decoration: underline;
  }
  cursor: pointer;
  font-size: ${props => props.theme.fontSizes.xs};
  font-weight: ${props => props.theme.fontWeights.bold};
  color: ${props => props.theme.colors.primaryPurple};
  margin-left: auto;
`;

export const StyledAnyEdits = styled.div`
  font-size: ${props => props.theme.fontSizes.xxs};
  font-weight: ${props => props.theme.fontWeights.light};
  line-height: 1.5;
  letter-spacing: ${props => props.theme.pxToRem(0.22)};
  color: ${props => props.theme.colors.neutralGrey8};
`;

export const StyledCheckBox = styled(Checkbox)`
  ${props => `
    &&&.ui.checkbox label {
      font-size: ${props.theme.fontSizes.xs};
      font-weight: ${props.theme.fontWeights.light};
    }
  `};
  width: ${props => props.theme.pxToRem(400)};
  height: ${props => props.theme.pxToRem(22)};
  font-weight: ${props => props.theme.fontWeights.light};
  color: ${props => props.theme.colors.neutralGrey8};
  display: inline-block;
  margin-bottom: ${props => props.theme.pxToRem(25)};
  margin-top: ${props => props.theme.pxToRem(20)};
`;

export const StyledDropdown = styled(Dropdown)`
  width: 100%;
  &&&&&.disabled {
    opacity: 1;
    background-color: ${props => props.theme.colors.neutralGrey2};
    input {
      color: ${props => props.theme.colors.neutralGrey8};
    }
  }

  &&&.ui.dropdown .menu > .item b {
    display: none;
  }

  &&&.ui.dropdown:not(.button) > .default.text {
    color: ${props =>
      props.name === 'role-selection' ? props.theme.colors.primaryPurple : props.theme.colors.neutralGrey8};
  }

  &&&&& {
    height: ${props => props.theme.pxToRem(44)};
    display: flex;
    color: ${props => props.theme.colors.primaryPurple};
    div {
      align-self: center;
    }
    i {
      padding-top: ${props => props.theme.pxToRem(12)};
    }
  }
`;

export const StyledCountryDropdown = styled(DropdownWithLabel)`
  .divider.text {
    cursor: pointer !important;

    .ui.image {
      margin-top: ${props => props.theme.pxToRem(-4)} !important;
    }
  }
`;

export const StyledCountryContainer = styled.div`
  max-width: ${props => props.theme.pxToRem(336)};
  margin-bottom: ${props => props.theme.pxToRem(10)};

  ${props => props.theme.mediaQueries.mobileOnly} {
    max-width: ${props => props.theme.pxToRem(296)};
  }
`;

export const StyledLabel = styled.label`
  display: flex;
  margin-bottom: ${props => props.theme.pxToRem(8)};
  font-weight: ${props => props.theme.fontWeights.regular};
`;

export const StyledInput2 = styled(Input)`
  &&&&& {
    margin-bottom: ${props => props.theme.pxToRem(19)};
  }
`;

export const StyledChangeRoleSpan = styled.span`
  font-size: ${props => props.theme.fontSizes.xxs};
`;

export const StyledRoleContainer = styled.div`
  margin-bottom: ${props => props.theme.pxToRem(30)};
`;

export const StyledLabelContainerWithEdit = styled.div`
  display: flex;
`;

export const StyledContainerCity = styled.div`
  max-width: 100%;
  margin-bottom: ${props => props.theme.pxToRem(19)};
`;

export const StyledContainerZIPCountry = styled.div`
  display: flex;
  column-gap: ${props => props.theme.pxToRem(20)};
  width: 100%;
`;

export const StyledContainerState = styled.div`
  margin-right: ${props => props.theme.pxToRem(16)};
`;

export const StyledContainerPhoneNumber = styled.div`
  width: 100%;
  margin-bottom: ${props => props.theme.pxToRem(19)};
`;

export const StyledInputWithValidation = styled(InputWithValidation)`
  &&& {
    display: flex;
    margin-bottom: ${props => props.theme.pxToRem(7)};
  }

  &&&.disabled {
    cursor: not-allowed;
    opacity: 1;
    input {
      border-color: ${props => props.theme.colors.neutralGrey4};
      background-color: ${props => props.theme.colors.neutralGrey2};
    }
  }

  &&&.business-name {
    width: 100%;
  }
`;

export const StyledResetLink = styled.div`
  &:hover {
    text-decoration: underline;
  }
  cursor: pointer;
  margin-top: ${props => props.theme.pxToRem(30)};
  font-size: ${props => props.theme.pxToRem(14)};
  font-weight: ${props => props.theme.fontWeights.medium};
  color: ${props => props.theme.colors.primaryPurple};
`;

export const StyledAdvancedSearch = styled.div`
  margin-top: ${props => props.theme.pxToRem(30)};
  font-size: ${props => props.theme.pxToRem(14)};
`;

export const StyledAdvancedSearchLink = styled.label`
  &:hover {
    text-decoration: underline;
  }
  cursor: pointer;
  font-weight: ${props => props.theme.fontWeights.medium};
  color: ${props => props.theme.colors.primaryPurple};
`;

export const StyledNotificationBanner = styled(NotificationBanner)`
  margin-top: ${props => props.theme.pxToRem(15)};
  margin-bottom: ${props => props.theme.pxToRem(20)};
`;

export const StyledIconError = styled(IconError)`
  flex: 0 0 ${props => props.theme.pxToRem(24)};
  width: ${props => props.theme.pxToRem(24)};
  height: ${props => props.theme.pxToRem(24)};
`;

export const StyledSearchOrganizationContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-top: ${props => props.theme.pxToRem(10)};
  column-gap: ${props => props.theme.pxToRem(10)};
`;

export const StyledSearchOrganizationFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 40%;
`;

export const StyledSearchButton = styled(Button)`
  flex-basis: ${props => props.theme.pxToRem(130)} !important;
  margin-top: ${props => props.theme.pxToRem(34)} !important;
  display: flex;

  ${props => props.theme.mediaQueries.tabletOnly} {
    margin-top: ${props => props.theme.pxToRem(57)} !important;
  }

  ${props => props.theme.mediaQueries.mobileOnly} {
    margin-top: ${props => props.theme.pxToRem(57)} !important;
  }
`;

export const StyledLink = styled.label`
  &:hover {
    text-decoration: underline;
  }
  cursor: pointer;
  font-weight: ${props => props.theme.fontWeights.medium};
  color: ${props => props.theme.colors.primaryPurple};
`;

export const StyledCenterDiv = styled.div`
  margin: ${props => props.theme.pxToRem(20)} 0;
`;

export const StyledCenterOrgTitle = styled.p`
  margin: ${props => props.theme.pxToRem(40)} 0 ${props => props.theme.pxToRem(15)} 0;
  font-size: ${props => props.theme.fontSizes.m};
  line-height: 1.33;
`;

export const StyledDescription = styled.p`
  font-weight: ${props => props.theme.fontWeights.light};
  font-size: ${props => props.theme.fontSizes.s};
`;
interface ValidationMessageProps {
  hasError?: boolean;
  absoluteErrorMessage?: boolean;
}

export const ValidationMessage = styled.div<ThemedStyledProps<ValidationMessageProps, DefaultTheme>>`
  margin-bottom: ${props => props.theme.pxToRem(4)};
  color: ${props => props.theme.colors.neutralGrey5};
  font-size: ${props => props.theme.fontSizes.xxs};
  background-color: #e7e7e7;
  margin-top: ${props => props.theme.pxToRem(5)};
  ${({ hasError, theme, absoluteErrorMessage }) =>
    hasError &&
    `
      color: ${theme.colors.interfaceRed};
      position: ${absoluteErrorMessage ? 'absolute' : 'static'}
    `}
`;

export const StyledMessage = styled.div`
  width: 100%;
  background-color: #e7e7e7;
  position: absolute;
`;

export const StyledCloseButton = styled(Button)`
  width: 0 !important;
  height: 0 !important;

  &&&& {
    background: none;
    border: none;
    float: right;
    padding: 0;
    margin-right: 1rem;

    :hover {
      background: none;
    }
  }
`;
